import store from 'source/store';
import TagsPageGroup from 'source/pages/root/TagsPageGroup.vue';

function checkIfUserIsEmployed(to, _from, next) {
    const employmentLocked = store.state.auth.user?.user_profile?.is_locked;
    const workforce_id = parseInt(to.params.workforce_id);
    let userWorkforces = store.state.auth.user.user_profile.workforce_ids;
    const isWorkforceValid = !userWorkforces.includes(workforce_id);
    if (to.name === 'tags' && employmentLocked || isWorkforceValid) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

export default [{
    path: 'tags/',
    component: TagsPageGroup,
    beforeEnter: checkIfUserIsEmployed,
    meta: {
        title: 'Tags - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: '',
            name: 'tags',
            component: () => import('source/pages/tags/TagsPage.vue'),
            meta: {
                title: 'Tags - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
        {
            path: 'new',
            name: 'tag-create',
            component: () => import('source/pages/tags/TagCreatePage.vue'),
            meta: {
                title: 'Create Tag - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
        {
            path: 'edit/:tag_id',
            name: 'tag-edit',
            component: () => import('source/pages/tags/TagCreatePage.vue'),
            props: true,
            meta: {
                title: 'Create Tag - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        }
    ]
}];
